"use strict";
/** Copyright: Microsoft 2019 */
Object.defineProperty(exports, "__esModule", { value: true });
var LocalizationApiProvider = /** @class */ (function () {
    function LocalizationApiProvider(filePrefix, filePostfix) {
        var _this = this;
        this.getFilename = function (locale) {
            return _this.filePrefix + locale + _this.filePostfix;
        };
        this.filePrefix = filePrefix;
        this.filePostfix = filePostfix;
    }
    LocalizationApiProvider.prototype.setNamespace = function (namespace) {
        this.namespace = namespace;
        return this;
    };
    LocalizationApiProvider.prototype.getStringTable = function (locale) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', _this.getFilename(locale));
            xhr.setRequestHeader('Accept', 'application/json');
            xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(JSON.parse(xhr.response));
                }
                else {
                    reject(xhr.statusText);
                }
            };
            xhr.onerror = function () { return reject(xhr.statusText); };
            xhr.send();
        });
    };
    LocalizationApiProvider.prototype.getNamespace = function () {
        return this.namespace;
    };
    return LocalizationApiProvider;
}());
exports.LocalizationApiProvider = LocalizationApiProvider;
